import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../index.css";

const Profile = () => {
  const [admin, setAdmin] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ name: "" });

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_BACKEND}/api/admin/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAdmin(res.data);
        setFormData({ name: res.data.name });
      } catch (err) {
        console.error("Error fetching profile:", err);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleUpdate = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.put(`${process.env.REACT_APP_BACKEND}/api/admin/profile`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdmin(res.data);
      setEditMode(false);
    } catch (err) {
      console.error("Error updating profile:", err);
    }
  };

  if (!admin) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="profile-container container mt-5">
      <div className="profile-card card shadow-sm mx-auto">
        <div className="card-body">
          <h4 className="card-title mb-4 text-center">Profile</h4>
          {editMode ? (
            <>
              <div className="form-group mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter name"
                />
              </div>
              <div className="d-flex justify-content-between">
                <button className="btn btn-success" onClick={handleUpdate}>
                  Save
                </button>
                <button className="btn btn-secondary" onClick={() => setEditMode(false)}>
                  Cancel
                </button>
              </div>
            </>
          ) : (
            <>
              <p><strong>Name:</strong> {admin.name}</p>
              <p><strong>Email:</strong> {admin.email}</p>
              <div className="text-center">
                <button className="btn btn-primary mt-3" onClick={() => setEditMode(true)}>
                  Edit Profile
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
